module.exports = __webpack_public_path__ + "img/icon-mail-white.svg";